module.exports = "/images/description_changed.png?ff74b816b08e7dfcc5e8a0e9baaa9ba4";